import { useEffect, useState } from 'react';

export const useSelectedSku = (defaultSkuId, privateOffer) => {
    const [selectedSkuId, setSelectedSkuId] = useState(defaultSkuId);
    const privateOfferId = privateOffer && privateOffer.skuId ? privateOffer.skuId : null;

    useEffect(() => {
        if (privateOfferId) {
            setSelectedSkuId(privateOfferId);
        }
    }, [privateOfferId]);

    return [selectedSkuId, setSelectedSkuId];
};
